import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import { RouterOutputs } from '../../../modules/trpc'

export type PendingContract = RouterOutputs['contact']['getPendingContracts'][number]

export interface PendingContractProps {
	contract: PendingContract
	disabled: boolean
	onSelect: (contract: PendingContract) => void
}

const PendingContract: React.FC<PendingContractProps> = ({ contract, disabled, onSelect }) => {
	const { t } = useTranslation('pages_contractInformation')

	const streetLine = [
		contract.streetAddress,
		contract.houseNumber,
		contract.stairwellIdentification,
		contract.apartment,
	]
		.filter(Boolean)
		.join(' ')
	const cityLine = [contract.zipCode, contract.city].filter(Boolean).join(' ')
	const isCancelled = contract.cancellationRequestedDate !== null

	return (
		<div
			className={`rounded-lg border p-3 flex flex-col gap-2 mt-1 ${
				isCancelled
					? 'border-gray-300 dark:border-gray-600 opacity-60'
					: 'border-brand-primary-100-light dark:border-brand-primary-100-dark'
			}`}
		>
			<div className='flex flex-col gap-0.5'>
				<div className='flex items-center justify-between gap-2'>
					<p className='font-semibold text-sm text-text-dark dark:text-white'>{contract.productName}</p>
					{isCancelled && (
						<span className='text-xs font-medium text-orange-500 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 rounded px-1.5 py-0.5 shrink-0'>
							{t('cancellationPending')}
						</span>
					)}
				</div>
				{streetLine && <p className='text text-xs dark:text-text-grey-100'>{streetLine}</p>}
				{cityLine && <p className='text text-xs dark:text-text-grey-100'>{cityLine}</p>}
				<p className='text text-xs dark:text-text-grey-100'>
					{t('alkamispaiva')}: {dayjs(contract.contractStartDate).format('DD.MM.YYYY HH:mm')}
				</p>
				<p className='text text-xs dark:text-text-grey-100'>
					{t('orderDate')}: {dayjs(contract.creationDate).format('DD.MM.YYYY HH:mm')}
				</p>
				{isCancelled && contract.cancellationRequestedDate && (
					<p className='text text-xs text-orange-500 dark:text-orange-400'>
						{t('cancellationDate')}:{' '}
						{dayjs(contract.cancellationRequestedDate).format('DD.MM.YYYY HH:mm')}
					</p>
				)}
			</div>

			{!isCancelled && (
				<Button color='danger' size='small' disabled={disabled} onClick={() => onSelect(contract)}>
					{t('cancelOrder')}
				</Button>
			)}
		</div>
	)
}

export default PendingContract
